import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { delay, get, isEqual } from 'lodash';
import { loadPlayer, loadPlayerSurvey, loadPlayerSurveysFilter, surveyStatus } from '../actions';
import { loadAsqSurveyResultsParentEmailSendout } from 'actions/asq';
import { resetErrorMessage } from 'actions/internal';
import { getLoaders, getTitle, getTeachersScores, getTeachersSurvey, isTeacherGradingFailed } from 'selectors';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import PlayerHeaderContainer from './player/PlayerHeaderContainer';
import PlayerSurveyContainer from './player/PlayerSurveyContainer';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
const CHECK_STATUS_TIMEOUT = 3500;

class ASQPlayerPage extends React.Component {
  initialize() {
    this.props.resetErrorMessage({ status: true });
    this.props.loadPlayer(this.props.match.params, { source: 'init' });
    this.props.loadPlayerSurvey(this.props.match.params, { source: 'init' });
    this.props.loadAsqSurveyResultsParentEmailSendout(this.props.match.params.id, 0);
  }

  componentDidMount() {
    this.initialize();
    this.props.loadPlayerSurveysFilter(this.props.match.params, { source: 'init' });
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.match.params, this.props.match.params)) {
      this.initialize();
    }
  }

  checkSurveyStatus() {
    const { playerId, teacherSurvey, surveyStatus } = this.props;
    delay(surveyStatus, CHECK_STATUS_TIMEOUT, playerId, teacherSurvey.id, teacherSurvey.asqJid);
  }

  render() {
    const { auth } = this.props;
    if (!auth.isAuthChecked) return null;
    const { isLoading, isScoreLoading, match, playerId, surveyId, title } = this.props;
    if (playerId !== parseInt(match.params.player_id, 10) ||
        surveyId !== parseInt(match.params.id, 10) || isLoading) {
      return (
        <DocumentTitle title={title}>
          <div>
            <TopNavBar />
            <SubNavBar />
            <div className='row'>
              <div className='column u-margin-top--large'>
                <LoadingSpinner bgColor='light' />
              </div>
            </div>
          </div>
        </DocumentTitle>
      );
    }
    const locationFrom = get(this.props.location, 'state.from', null);
    if (isScoreLoading) this.checkSurveyStatus();
    return (
      <DocumentTitle title={title}>
        <div>
          <TopNavBar withPlayer={true} />
          <SubNavBar />
          <div className='row'>
            <div className="column">
              <PlayerHeaderContainer locationFrom={locationFrom}/>
              <PlayerSurveyContainer playerId={playerId} isLoading={isScoreLoading} locationFrom={locationFrom}/>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isLoading: getLoaders(state, ['PLAYER', 'PLAYER_SURVEY', 'PLAYER_FILTER']),
    playerId: get(state.player.player, 'id', 0),
    surveyId: get(state.player.survey, 'result.questionnaires.parent', 0),
    teacherSurvey: getTeachersSurvey(state),
    title: getTitle(state.player.player, 'name'),
    isTeacherGradingFailed: isTeacherGradingFailed(state),
    isScoreLoading: getTeachersScores(state),
  }
}

ASQPlayerPage.propTypes = {
  auth: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isTeacherGradingFailed: PropTypes.bool.isRequired,
  isScoreLoading: PropTypes.bool.isRequired,
  loadPlayer: PropTypes.func.isRequired,
  loadPlayerSurvey: PropTypes.func.isRequired,
  loadAsqSurveyResultsParentEmailSendout: PropTypes.func.isRequired,
  loadPlayerSurveysFilter: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
  surveyStatus: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  playerId: PropTypes.number,
  surveyId: PropTypes.number,
  teacherSurvey: PropTypes.object,
  title: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, {
  loadPlayer,
  loadPlayerSurvey,
  loadAsqSurveyResultsParentEmailSendout,
  loadPlayerSurveysFilter,
  resetErrorMessage,
  surveyStatus,
})(ASQPlayerPage);
